"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var preact_1 = require("preact"); // 알림 항목 아이콘 출력


function Icon(_ref) {
  var type = _ref.type;

  switch (type) {
    case "F01":
    case "F21":
      return (0, preact_1.h)("em", {
        class: "icf_live"
      }, "\uC2A4\uD2B8\uB9AC\uBA38 \uC0C8 \uBC29\uC1A1 \uC54C\uB9BC");

    case "F03":
    case "F04":
    case "F05":
      return (0, preact_1.h)("em", {
        class: "icf_vod"
      }, "\uC2A4\uD2B8\uB9AC\uBA38 \uC0C8 VOD \uC54C\uB9BC");

    case "F02":
      return (0, preact_1.h)("em", {
        class: "icf_bj_post"
      }, "\uC2A4\uD2B8\uB9AC\uBA38 \uC0C8 \uAC8C\uC2DC\uAE00 \uC54C\uB9BC");

    case "F12":
      return (0, preact_1.h)("em", {
        class: "icf_bj_post"
      }, "\uC2A4\uD2B8\uB9AC\uBA38 \uB9E4\uB2C8\uC800\uC758 \uC0C8 \uAC8C\uC2DC\uAE00 \uC54C\uB9BC");

    case "F06":
      return (0, preact_1.h)("em", {
        class: "icf_bj_text"
      }, "\uC2A4\uD2B8\uB9AC\uBA38 \uC0C8 \uBC29\uBA85\uB85D \uAE00 \uC54C\uB9BC");

    case "F11":
      return (0, preact_1.h)("em", {
        class: "icf_bj_msg"
      }, "\uC2A4\uD2B8\uB9AC\uBA38 \uBA54\uC2DC\uC9C0 \uC54C\uB9BC");

    case "A01":
    case "A02":
    case "A03":
    case "A04":
    case "A05":
    case "A14":
    case "A15":
    case "A16":
    case "A17":
    case "C11":
    case "C21":
    case "C31":
    case "C14":
    case "C24":
    case "C34":
      return (0, preact_1.h)("em", {
        class: "icf_text"
      }, "\uB313\uAE00/\uB2F5\uAE00 \uC54C\uB9BC");

    case "A07":
    case "A08":
    case "A09":
    case "A10":
    case "A12":
    case "A13":
    case "C17":
    case "C27":
    case "C37":
    case "C19":
    case "C29":
    case "C39":
      return (0, preact_1.h)("em", {
        class: "icf_up"
      }, "UP \uC54C\uB9BC");

    case "A11":
      return (0, preact_1.h)("em", {
        class: "icf_message"
      }, "\uCABD\uC9C0 \uC54C\uB9BC");

    case "B02":
      return (0, preact_1.h)("em", {
        class: "icf_mypost"
      }, "\uC0C8 \uAC8C\uC2DC\uAE00 \uC54C\uB9BC");

    case "B06":
      return (0, preact_1.h)("em", {
        class: "icf_mytext"
      }, "\uC0C8 \uBC29\uBA85\uB85D \uC54C\uB9BC");

    case "B03":
    case "B04":
    case "B07":
      return (0, preact_1.h)("em", {
        class: "icf_myvod"
      }, "VOD \uC54C\uB9BC");

    case "S01":
    case "S08":
    case "S02":
    case "S03":
    case "S04":
      return (0, preact_1.h)("em", {
        class: "icf_balloon"
      }, "\uBCC4\uD48D\uC120 \uC54C\uB9BC");

    case "S05":
    case "S06":
      return (0, preact_1.h)("em", {
        class: "icf_sticker"
      }, "\uC2A4\uD2F0\uCEE4 \uC54C\uB9BC");

    case "S07":
      return (0, preact_1.h)("em", {
        class: "icf_choco"
      }, "\uCD08\uCF5C\uB9BF \uC54C\uB9BC");

    case "S09":
    case "S10":
    case "S16":
      return (0, preact_1.h)("em", {
        class: "icf_ad"
      }, "\uC560\uB4DC\uBC8C\uB8EC \uC54C\uB9BC");

    case "S11":
    case "S12":
    case "S13":
    case "S14":
      return (0, preact_1.h)("em", {
        class: "icf_subscribe"
      }, "\uAD6C\uB3C5 \uC54C\uB9BC");

    case "S15":
      return (0, preact_1.h)("em", {
        class: "icf_quickview"
      }, "\uD035\uBDF0 \uC54C\uB9BC");
  }

  return null;
}

exports.default = Icon;